export default __webpack_public_path__ + "static/media/lodgify_step7.cfe06a92.jpg";